import type { Maybe } from '@vrplatform/utils';
import { useDebouncedValue } from '@mantine/hooks';
import { useMemo } from 'react';
import type { ListingData } from '../detail/useListingDetailViewQuery';
import { ListingDeactivationModal } from './ListingDeactivationModal';
import { ListingOpeningBalanceModal } from './ListingOpeningBalanceModal';

type Props = {
  listing: {
    id: string;
    name: Maybe<string>;
    deactivation: ListingData['deactivation'];
    activeOwnership?: Maybe<ListingData['activeOwnership']>;
    activeRecurringFeePeriods?: ListingData['activeRecurringFeePeriods'];
  } | null;
  // deleteModal: {
  //   opened: boolean;
  //   closeModal: () => void;
  //   onSuccess?: () => void;
  // };
  deactivationModal: {
    opened: boolean;
    closeModal: () => void;
  };
  openingBalanceModal: {
    opened: boolean;
    closeModal: () => void;
  };
};

export const ListingEllipsisMenuModals = ({
  // deleteModal,
  listing: initial,
  deactivationModal,
  openingBalanceModal,
}: Props) => {
  const [debounced] = useDebouncedValue(initial, 500);
  const listing = initial || debounced;

  if (!listing) return null;

  return (
    <>
      {/* <Delete listing={listing} {...deleteModal} /> */}
      <Deactivation listing={listing} {...deactivationModal} />
      <ListingOpeningBalanceModal
        listingId={listing.id}
        closeModal={openingBalanceModal.closeModal}
        opened={openingBalanceModal.opened}
      />
    </>
  );
};

const Deactivation = ({
  listing,
  ...props
}: {
  listing: NonNullable<Props['listing']>;
} & Props['deactivationModal']) => {
  const l = useMemo(() => {
    return {
      id: listing.id,
      deactivation: listing.deactivation!,
      activeOwnership: listing.activeOwnership,
      activeRecurringFeePeriods: listing.activeRecurringFeePeriods,
    };
  }, [listing]);

  return <ListingDeactivationModal listing={l} {...props} />;
};

// const Delete = ({
//   closeModal,
//   listing: initial,
//   opened,
//   onSuccess,
// }: {
//   listing: NonNullable<Props['listing']>;
// } & Props['deleteModal']) => {
//   const [debounced] = useDebouncedValue(initial, 500);

//   const listing = initial || debounced;

//   const invalidate = useInvalidateHasuraQueries(['listings']);

//   const { mutateAsync, isPending: loading } = useApiMutation(
//     'delete',
//     '/listings/{id}',
//     {
//       onSettled: () => {
//         invalidate();
//       },
//     }
//   );

//   const submit = async (isSecondConfirm: boolean) =>
//     await mutateAsync({
//       params: {
//         path: {
//           id: listing.id,
//         },
//         query: {
//           onLocked: isSecondConfirm ? 'archive' : 'error',
//         },
//       },
//     })
//       .then(() => {
//         onSuccess?.();
//         closeModal();
//         invalidate();
//       })
//       .catch((err: any) => {
//         if (err?.message.includes('pass onLocked=archive to archive')) {
//           return {
//             showConfirm: true,
//           };
//         } else {
//           showApiErrorNotification({
//             error: err,
//             title: 'Failed to delete listing',
//             defaultMessage:
//               'We failed to delete listing. Please reach out to support if the issue persists.',
//           });
//         }
//       });

//   return (
//     <ConfirmModal
//       type="delete"
//       opened={opened}
//       closeModal={closeModal}
//       title={`Are you sure to delete ${
//         listing.name ? listing.name : 'this listing'
//       }?`}
//       subtitle="Once deleted all data will be lost."
//       onSubmit={submit}
//       loading={loading}
//       secondConfirm={{
//         title: 'We have found data associated with this listing',
//         subtitle:
//           'We have found data associated with this listing. Would you like to archive the listing instead? This will keep the data associated with the listing, but will remove it from your dashboard.',
//         submitTitle: 'Archive listing',
//       }}
//     />
//   );
// };
